import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISourceBase } from '../../interfaces/sources';

// Тут asc — порядок сортування за замовчанням, isAlpha — чи є поле string
export const SOURCE_ORDER_DEFAULT: { [key in keyof Partial<ISourceBase>]: { asc: boolean; isAlpha: boolean } } = {
	id: { asc: false, isAlpha: false },
	title: { asc: true, isAlpha: true },
	update_date: { asc: false, isAlpha: false },
};
interface IManageSlice {
	sourceTerm: string;
	sourceOrderField: keyof ISourceBase;
	sourcePageNo: number;
	sourceNotRankedOnly: boolean;
	sourceOrderAsk: boolean;
}
const initialState: IManageSlice = {
	sourceTerm: '',
	sourceOrderField: 'id',
	sourcePageNo: 0,
	sourceNotRankedOnly: false,
	sourceOrderAsk: false,
};
export const manageSlice = createSlice({
	name: 'manage',
	initialState,
	reducers: {
		changeSourceTerm: (state, action: PayloadAction<string>) => {
			if (state.sourceTerm === action.payload) return;
			state.sourceTerm = action.payload;
			state.sourcePageNo = 0;
		},
		changeSourceOrder: (state, action: PayloadAction<keyof ISourceBase>) => {
			if (state.sourceOrderField === action.payload) state.sourceOrderAsk = !state.sourceOrderAsk;
			else {
				state.sourceOrderField = action.payload;
				state.sourceOrderAsk = SOURCE_ORDER_DEFAULT[action.payload]?.asc ?? false;
			}
			state.sourcePageNo = 0;
		},
		changeSourcePageNo: (state, action: PayloadAction<number>) => {
			state.sourcePageNo = action.payload;
		},
		changeNotRankedOnly: (state, action: PayloadAction<boolean>) => {
			if (state.sourceNotRankedOnly === action.payload) return;
			state.sourceNotRankedOnly = action.payload;
			state.sourcePageNo = 0;
		},
	},
});

export const { changeSourceTerm, changeSourceOrder, changeSourcePageNo, changeNotRankedOnly } = manageSlice.actions;

export default manageSlice.reducer;
